import { createTheme, PaletteMode } from '@mui/material';
import { ruRU } from '@mui/x-data-grid';
import type {} from '@mui/x-data-grid/themeAugmentation';
import { LANGUAGE_RUS } from '../constant/constants';

export const createAppTheme = (mode: PaletteMode, language: string) => {
  const isDark = mode === 'dark';
  const background = isDark ? '#16181b' : '#eeeeee';
  const paper = isDark ? '#24272b' : '#ffffff';
  const text = isDark ? '#f1f3f5' : '#000000';
  const secondaryText = isDark ? '#b6bec7' : '#757575';
  const divider = isDark ? '#454c54' : 'rgba(0, 0, 0, 0.12)';

  return createTheme(
    {
      palette: {
        mode,
        primary: { main: isDark ? '#90caf9' : '#1976d2' },
        background: { default: background, paper },
        text: { primary: text, secondary: secondaryText },
        divider,
      },
      components: {
        MuiCssBaseline: {
          styleOverrides: {
            ':root': {
              '--app-background': background,
              '--app-paper': paper,
              '--app-text-primary': text,
              '--app-text-secondary': secondaryText,
              '--app-dialog-background': isDark ? paper : '#e7ebee',
              '--app-section-background': isDark ? '#343a40' : '#9e9e9e',
              '--app-selected-background': isDark ? '#36495b' : '#d5d5d5',
              '--app-task-background': isDark ? '#254b38' : '#a5d6a7',
              '--app-archive-success': isDark ? '#254b38' : 'green',
              '--app-archive-warning': isDark ? '#634c24' : 'orange',
              '--app-archive-error': isDark ? '#63383b' : '#ef5350',
            },
          },
        },
        MuiAppBar: {
          styleOverrides: {
            root: {
              backgroundColor: isDark ? '#191b1f' : '#212121',
              color: '#ffffff',
              backgroundImage: 'none',
            },
          },
        },
        MuiPaper: {
          styleOverrides: { root: { backgroundImage: 'none' } },
        },
        MuiDialog: {
          styleOverrides: {
            paper: { backgroundColor: 'var(--app-dialog-background)' },
          },
        },
        MuiDataGrid: {
          styleOverrides: {
            root: { backgroundColor: paper, color: text, borderColor: divider },
            columnHeaders: {
              backgroundColor: isDark ? '#2d3238' : '#f5f5f5',
              borderColor: divider,
            },
            cell: { borderColor: divider },
            footerContainer: { borderColor: divider },
          },
        },
      },
    },
    language === LANGUAGE_RUS ? ruRU : {}
  );
};
